document.addEventListener("DOMContentLoaded", function () {
    if (window.prettyPrint) {
        prettyPrint();
    }
});
